import { render } from "./BottomMenuMobileItem.vue?vue&type=template&id=4dd4e66e&scoped=true"
import script from "./BottomMenuMobileItem.vue?vue&type=script&lang=js"
export * from "./BottomMenuMobileItem.vue?vue&type=script&lang=js"

import "./BottomMenuMobileItem.vue?vue&type=style&index=0&id=4dd4e66e&lang=stylus&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dd4e66e"]])

export default __exports__